<template lang="html">
    <div ref="chartwrapper" class="chartwrapper"></div>
</template>

<script>
export default {
  props: {
    dataEntry: Array,
    labelsEntry: Array,
    uni_color: Object,
    colors: Array
  },
  data() {
    return {
      personalColor: {},
      drawed: false,
      selectedAssetIndex: 0
    };
  },
  mounted() {
      // If the uni_color object was send them we will draw our donut differently
      // if (this.uni_color != undefined) {
      //   this.personalColor = this.uni_color;
      //   this.colorPosition = this.labels.indexOf(this.personalColor.name);
      // }
  },
  watch: {
    dataEntry: "draw"
  },
  methods: {
    clickCallback(d, i) {
      const assetClass = this.labelsEntry[i].replace(/\s+/g, '').toLowerCase()
      this.$router.push(
        `/analisis-portafolio/${this.$route.params.id}/mercado/${assetClass}`
      );
    },
    draw() {
      if (this.drawed){
        return;
      }
      const dataset = this.dataEntry;
      const labels = this.labelsEntry;
      var colors = this.colors
      if (this.uni_color) {
        this.colorPosition = this.labelsEntry.indexOf(this.uni_color.name);
        var personalColor = true;
        var percentajeElement = dataset[this.colorPosition] * 1000 / 10;
        /* if our percentaje number is a float */
        let num = percentajeElement;
        if (num % 1 != 0) {
          num = num.toFixed(2);
          percentajeElement = Number(num);
        }
      }

      const width = document.querySelector(".chartwrapper").offsetWidth;
      const height = document.querySelector(".chartwrapper").offsetHeight;
      const minOfWH = Math.min(width, height) / 2;
      const initialAnimDelay = 0;
      const arcAnimDelay = 10;
      const arcAnimDur = 2000;
      /* delay for the sec animations */
      const secDur = 1000;
      const secIndividualdelay = 150;
      let radius;
      // calculate minimum of width and height to set chart radius
      if (minOfWH > 150) {
        radius = 150;
      } else {
        radius = minOfWH;
      }
      // append svg
      let chartwrapper = this.$refs.chartwrapper;
      let svg = d3
        .select(chartwrapper)
        .append("svg")
        .attr({
          width: width,
          height: height,
          class: "pieChart"
        })
        .append("g");
      svg.attr({
        transform: `translate(${width / 2}, ${height / 2})`
      });
      // for drawing slices, also it manages the proportion of the circle in
      // relation of the canvas
      let arc = d3.svg
        .arc()
        .outerRadius(radius * (0.6 * 1.1))
        .innerRadius(radius * (0.45 * 1.1));
      // for labels and polylines
      let outerArc = d3.svg
        .arc()
        .innerRadius(radius * 0.85)
        .outerRadius(radius * 0.85);
      // d3 color generator
      let pie = d3.layout.pie().value(d => d);
      let draw = function(clickFunction) {
        svg.append("g").attr("class", "lines");
        svg.append("g").attr("class", "slices");
        svg.append("g").attr("class", "labels");
        // define slice
        let slice = svg
          .select(".slices")
          .datum(dataset)
          .selectAll("path")
          .data(pie);
        slice
          .enter()
          .append("path")
          .attr({
            fill: (d, i) => colors[i],
            d: arc,
            "stroke-width": "25px",
            transform: (d, i) => "rotate(-180, 0, 0)"
          })
          .style("opacity", 0)
          .transition()
          .delay((d, i) => i * arcAnimDelay + initialAnimDelay)
          .duration(arcAnimDur)
          .ease("elastic")
          .style("opacity", 1)
          .attr("transform", "rotate(0,0,0)");

        slice
          .transition()
          .delay((d, i) => arcAnimDur + i * secIndividualdelay)
          .duration(secDur)
          .attr("stroke-width", "5px");

        let midAngle = d => d.startAngle + (d.endAngle - d.startAngle) / 2;

        // CHART TEXT AND DOTTED LINES
        if (dataset.length === 2) {
          let text = svg
            .select(".labels")
            .selectAll("text")
            .data(pie(dataset));
          text
            .enter()
            .append("text")
            .attr("dy", "0.3em")
            .style("opacity", 0)
            .style("fill", "#4A4A4A")
            .text((d, i) => labels[i])
            .attr("transform", d => {
              // calculate outerArc centroid for 'this' slice
              let pos = outerArc.centroid(d);
              // define left and right alignment of text labels
              pos[0] = radius * (midAngle(d) < Math.PI ? 1 : -1);
              return `translate(${pos})`;
            })
            .style("text-anchor", d => (midAngle(d) < Math.PI ? "start" : "end"))
            .transition()
            .delay((d, i) => arcAnimDur + i * secIndividualdelay)
            .duration(secDur)
            .style("opacity", 1);
          // Here we draw the line that connects the text with their slices
          let polyline = svg
            .select(".lines")
            .selectAll("polyline")
            .data(pie(dataset));
          polyline
            .enter()
            .append("polyline")
            .style("opacity", 0.5)
            .attr("points", d => {
              let pos = outerArc.centroid(d);
              pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
              return [arc.centroid(d), arc.centroid(d), arc.centroid(d)];
            })
            .transition()
            .duration(secDur)
            .delay((d, i) => arcAnimDur + i * secIndividualdelay)
            .attr("points", d => {
              let pos = outerArc.centroid(d);
              pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
              return [arc.centroid(d), outerArc.centroid(d), pos];
            });
          }

        // Here we add the inner text to our donnut component
        if (personalColor || dataset.length === 1) {
          svg
            .append("text")
            .attr("dy", "0.26em")
            .style("text-anchor", "middle")
            .attr("class", "inner-circle")
            .attr("fill", "#848484")
            .text(function(d) {
              if (personalColor) {
              return percentajeElement + "%";
              } else {
                return "100%"
              }
            });
        }
        slice.on("click", clickFunction);
      };
      this.drawed = true;
      draw(this.clickCallback);
    }
  }
};
</script>
<style media="screen">
.chartwrapper path {
  stroke: white;
  stroke-width: 4px;
  /* cursor: pointer; */
  transition: fill 250ms;
}

text.inner-circle {
  font-weight: 400;
  font-size: 27px;
  text-transform: uppercase;
  /* font-family: "Avenir Next" !important; */
}
</style>
<style lang="css" scoped>
$primColor: #0d0d0d;
$secColor: #f48073;

body {
  overflow: hidden;
  font-size: 0.9em;
}

.chartwrapper {
  width: 500px;
  height: 400px;
  position: absolute;
}

text {
  font-size: 0.8em;
  letter-spacing: 0.5px;
  font-weight: 500;
}
</style>
<style lang="css">
.chartwrapper polyline {
  fill: none;
  stroke: #545454 /*$secColor*/;
  stroke-width: 1px;
  stroke-dasharray: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/DonnutChartD3.vue